export default "__VITE_ASSET__3566f8e5__$_?nuxt_component=async__"